import { environment } from './../environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class AppConfig{
  public readonly releaseVersion = '20241030.0800';
  public readonly apiUrl = environment.apiUrl;
  public readonly apiV2Url = "/v2/";
  public readonly KYCUrl = environment.KYCUrl;
  public readonly demoSite = environment.demoSite || false;
  public readonly privacyPageLink = environment.privacyPageLink || '';

  public readonly mobileAppShowLinks = environment.mobileAppShowLinks || false;
  public readonly mobileAppAndroidLink = environment.mobileAppAndroidLink || '';
  public readonly mobileAppIphoneLink = environment.mobileAppIphoneLink || '';

  public readonly pgfLaunchUtc = '2024-07-30T21:00:00';

  public readonly forgotPassword={
    getTFAProviders: this.apiUrl + "account/forgotpassword/GetTFAProviders"
  };

  public readonly login={
    loginUrl: this.apiUrl + "account/login",
    logoutUrl: this.apiUrl + "account/logout",
    loginC360: this.apiUrl + "account/c360login",
    sendCodeUrl: this.apiUrl + "account/login/sendtfacode",
    getSessionUrl: this.apiUrl + "account/session",
    verifyCodeUrl: this.apiUrl + "account/login/verifytfacode",
  };

  public readonly resetPassword={
    verifyCodeUrl: this.apiUrl + "account/resetpassword/verifyurl",
    passwordResetUrl:this.apiUrl + "account/resetpassword/reset",
    passwordChangeUrl: this.apiUrl + "account/changepassword",
  };

  public readonly profile={
    profileUrl: this.apiUrl + "profile/getProfile",
    getReRgsRelated: this.apiUrl + "profile/getReRgsRelated",
    getReRgsAdvisors: this.apiUrl + "profile/getReRgsAdvisors",
    welcomeMsgUrl: this.apiUrl + "profile/welcomemessage",
    notificationCountUrl: this.apiUrl + 'profile/getNewNotificationsCount',
    notificationsUrl: this.apiUrl + 'profile/getNotifications',
    markNotificationViewUrl: this.apiUrl + 'profile/MarkNotificationsViewed',
    getKycGuidUrl: this.apiUrl + 'profile/getKYCGUID',
    markNotificationsDoNotShowUrl: this.apiUrl + 'profile/markNotificationsDoNotShow',
  }

  public readonly portfolio = {
    portfolioSummaryUrl: this.apiUrl + "portfolio/summary",
    portfolioAssets: this.apiUrl + "portfolio/details/assetsbyplan",
    portfolioPlansSummaryUrl: this.apiUrl + "portfolio/planssummary",
    portfolioValuationDatesUrl: this.apiUrl + "portfolio/ValuationDates",
    portfolioSummaryCalendarYearReturnsUrl: this.apiUrl + "portfolio/summary/calendarYearReturns",
    portfolioDetailsCalendarYearReturnsUrl: this.apiUrl + "portfolio/details/calendarYearReturns",
    portfolioSummaryAnnualizedReturnsUrl: this.apiUrl + "portfolio/summary/annualizedReturns",
    portfolioSummaryTotalAmountInvestedUrl: this.apiUrl + "portfolio/summary/totalAmountInvested",
    portfolioDetailsTotalAmountInvestedUrl: this.apiUrl + "portfolio/details/totalAmountInvested",
    portfolioSummaryCashFlowAnnualUrl: this.apiUrl + "portfolio/summary/cashFlowAnnual",
    portfolioDetailsCashFlowRollingUrl: this.apiUrl + "portfolio/details/cashFlowRolling",
    portfolioAssetAllocationUrl: this.apiUrl + "portfolio/summary/assetAllocation",
    portfolioAssetAllocationGroupUrl: this.apiUrl + "portfolio/summary/assetAllocationGroup",
    portfolioDetailsTotalsUrl: this.apiUrl + "portfolio/summary/potfoliototals",
    contributionsWithdrawalsUrl: this.apiUrl + "portfolio/contrib/paged",
    chart: {
      reportName: "CLWEBAssetAllocationChart",
      reportItem: "AssetSubclass",
    },
    portfolioUSDExposureUrl: this.apiUrl + "portfolio/summary/USDExposure"
  }

  public readonly pgf = {
    getDisbursementDonationUrl: this.apiUrl + "pgf/getDisbursementDonation",
    getNewsUrl: this.apiUrl + "pgf/getNews",
  }

  public readonly accountantDocuments = {
    clientsUrl: this.apiV2Url + "accountant-clients",
    clientDocumentsUrl: this.apiV2Url + "accountant-client-documents",
    downloadUrl: this.apiV2Url + "download-document",
    bulkDownloadUrl: this.apiV2Url + "download-documents-bulk",
  }

  public readonly advisor = {
    restrictedFileTypesUrl: this.apiUrl + "advisor/restrictedTypes",
    advisorUrl: this.apiUrl + "advisor/getAdvisors",
    sendMailWithAttachment: this.apiUrl + "advisor/mail",
    getLinkedClients: this.apiUrl + "advisor/getLinkedClients",
    maxFileUploadSize: 26214400   // in bytes (25 MB equivalent)
  }

  public readonly resources = {
    priceUrl: this.apiUrl + "resource/fundpricing",
    newsletterUrl: this.apiUrl + "resource/newsletter",
    financialStatementsUrl: this.apiUrl + 'resource/financialstatements/paged',
    reportConfigUrl: this.apiUrl + 'resource/reportConfig',
    imageBaseUrl: "https://clientaccess.nicolawealth.com",
    contentBaseUrl: "https://clientaccess.nicolawealth.com",
    downloadfileUrl:this.apiUrl+"files/download",
    pageSize:15
  }

  public readonly document = {
    pagedDocumentUrl: this.apiUrl + "document/page",
    documentReadUrl: this.apiUrl + "document/read",
    documentUrl: this.apiUrl + "document",
    documentPageSize: 20,
    documentsLastViewed: this.apiUrl + 'document/getLastViewed'
  }

  public readonly passwordRules = {
    minLength: 12,
    maxLength: 72,
  }

  public readonly regex = {
    upperLowerCase: '^(?=.*[a-z])(?=.*[A-Z]).*$',
    specialChars: '^(?=.*[^A-Za-z0-9_]).*$',
    numbers: '^(?=.*[0-9]).*$'
  }

}
